import { useSelector } from 'react-redux'
import { AppState } from '../../index'

export const useUserId = (): string | undefined => {
  return useSelector<AppState, AppState['user']['userId']>((state) => {
    return state.user.userId
  })
}
